import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { SystemService } from '@codegen/Vaimoo.Admin.API';
import { environment } from 'src/environments/environment';
import { MenuItem } from '../models/menu-item.model';
import { UserOverlayComponent } from './user-overlay.component';
import { UserThumbsComponent } from '@shared/components/user-thumbs.component';
import { TooltipModule } from 'primeng/tooltip';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'va-navbar',
  template: `
    <nav class="navbar">
      <a href="/" class="navbar-logo"></a>

      @if (menuItems.length > 0) {
        <ul class="navbar-list">
          @for (menu of menuItems; track menu) {
            @if (menu?.IsSpacer) {
              <li class="navbar-spacer"></li>
            } @else if (menu?.IsUser) {
              <li class="navbar-item navbar-item-user">
                <a class="navbar-link" (click)="userOverlay.userDetails.toggle($event)">
                  <va-user-thumbs [firstname]="userInfo?.firstName" [lastname]="userInfo?.lastName" [size]="32" />
                  <va-user-overlay #userOverlay [userInfo]="userInfo"></va-user-overlay>
                </a>
              </li>
            } @else {
              <li class="navbar-item" [class.has-dropdown]="menu.Childs.length > 0">
                <a
                  class="navbar-link"
                  #rla="routerLinkActive"
                  [routerLink]="menu.RouterLink"
                  routerLinkActive="active"
                >
                  <i class="va-icon" [ngClass]="menu?.Icon" [class.va-active]="rla.isActive"></i>
                  <span class="navbar-label">{{ menu.Label | translate }}</span>
                  @if (menu.Childs.length > 0) {
                    <i class="pi pi-angle-down navbar-caret"></i>
                  }
                </a>

                @if (menu.Childs.length > 0) {
                  <div class="navbar-dropdown">
                    <ul class="dropdown-list">
                      @for (child of menu.Childs; track child) {
                        <li class="dropdown-item" [class.has-flyout]="child.Childs.length > 0">
                          <a
                            class="dropdown-link"
                            #rla2="routerLinkActive"
                            routerLinkActive="active"
                            [routerLink]="child.RouterLink"
                          >
                            <span>{{ child.Label | translate }}</span>
                            @if (child.Childs.length > 0) {
                              <i class="pi pi-angle-right dropdown-caret"></i>
                            }
                          </a>

                          @if (child.Childs.length > 0) {
                            <div class="dropdown-flyout">
                              <ul class="dropdown-list">
                                @for (subChild of child.Childs; track subChild) {
                                  <li class="dropdown-item" [class.has-flyout]="subChild.Childs.length > 0">
                                    <a
                                      class="dropdown-link"
                                      #rla3="routerLinkActive"
                                      routerLinkActive="active"
                                      [routerLink]="subChild.RouterLink"
                                    >
                                      <span>{{ subChild.Label | translate }}</span>
                                      @if (subChild.Childs.length > 0) {
                                        <i class="pi pi-angle-right dropdown-caret"></i>
                                      }
                                    </a>

                                    @if (subChild.Childs.length > 0) {
                                      <div class="dropdown-flyout">
                                        <ul class="dropdown-list">
                                          @for (leaf of subChild.Childs; track leaf) {
                                            <li class="dropdown-item">
                                              <a
                                                class="dropdown-link"
                                                #rla4="routerLinkActive"
                                                routerLinkActive="active"
                                                [routerLink]="leaf.RouterLink"
                                              >
                                                <span>{{ leaf.Label | translate }}</span>
                                              </a>
                                            </li>
                                          }
                                        </ul>
                                      </div>
                                    }
                                  </li>
                                }
                              </ul>
                            </div>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                }
              </li>
            }
          }
        </ul>
      }

      <div class="navbar-version" [pTooltip]="version" tooltipPosition="bottom">
        <i class="pi pi-info-circle"></i>
      </div>
    </nav>
  `,
  standalone: true,
  imports: [
    TooltipModule,
    RouterLinkActive,
    RouterLink,
    NgClass,
    UserOverlayComponent,
    UserThumbsComponent,
    TranslateModule,
  ],
})
export class NavbarComponent implements OnInit {
  private systemService = inject(SystemService);

  @ViewChild('userOverlay') userOverlay: UserOverlayComponent;

  @Input() menuItems: MenuItem[] = [];
  @Input() userInfo: any;
  @Output() menuOnChange: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  version = '';

  constructor() {
    this.systemService.pingGet().subscribe((res) => {
      this.version = `FE: v${environment.buildNumber} (${environment.release}) | BE: v${res.version}`;
    });
  }

  ngOnInit(): void {}
}
